import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import Header from './header';
import Navigation from './navigation';
import BottomFooter from './footer';
import TabBox from './tabBox';
import Slider from './slider';
import HeadLines from './headLines';
import ThreeImageAd from './threeImageAd';
import BigImageAd from './bigImageAd';
import transform from 'chipDataTransform';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Iframe from '@src/pc/hk/layout/components/iframe';
import ModuleHead from '@src/pc/hk/layout/components/moduleHead';
import ImageTextShadow from '@src/pc/hk/layout/components/imageTextShadow';
import Space from '@src/pc/hk/layout/components/space';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();

        window.addEventListener(
            'message',
            event => {
                if (event?.data?.rjhPath) {
                    window.open(
                        `${location.protocol}//${location.hostname}/hkSub?iframeUrl=${event.data.rjhPath}`,
                        'target',
                        '',
                    );
                }
            },
            false,
        );
    }

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const {
            nav,
            search,
            logo,
            subLogo,
            footer,
            navigation,
            headLines,
            slideList,
            surveyList,
            meetingList,
            headLinesAd,
            hkSurveyHead,
            meetingHead,
            longImageAd,
            tabInfoTitle,
            tabInfoAd,
            tabHardAd,
            tabLiveLogo,
            topBigImage,
            longStockNumber,
            newVoice,
            rightStock,
            bottomStock,
            allDayNews,
        } = content;

        const headerData = {
            nav,
            search,
            logo,
            subLogo,
        };

        const footerData = {
            footer,
        };

        return (
            <>
                <Header content={headerData} />
                <Chip id="30007" type="struct" title="财经导航" groupName="导航栏" content={navigation}>
                    <Navigation />
                </Chip>
                <div className={styles.col_1000}>
                    {/* <Chip id="260383" type="struct" title="通栏指数" groupName="通栏指数" content={longStockNumber}>
                        <Iframe />
                    </Chip> */}
                    <div id="fiu_top" />
                </div>
                <div className={styles.col_1000}>
                    <div className={styles.col_640}>
                        <Chip id="286172" type="recommend" title="焦点图" groupName="焦点图" content={slideList}>
                            <Slider />
                        </Chip>
                        {/* <Chip id="260384" type="struct" title="最新播报" groupName="最新播报" content={newVoice}>
                            <Iframe />
                        </Chip> */}
                        <div id="fiu_marquee" />
                        <Chip id="286171" type="recommend" title="头条" groupName="头条" content={headLines}>
                            <HeadLines />
                        </Chip>
                        {headLinesAd?.length === 3 && (
                            <Chip id="260372" type="struct" title="三图广告" groupName="三图广告" content={headLinesAd}>
                                <ThreeImageAd />
                            </Chip>
                        )}
                        <TabBox
                            content={{
                                infoTitle: tabInfoTitle,
                                infoAd: tabInfoAd,
                                hardAd: tabHardAd,
                                liveLogo: tabLiveLogo,
                            }}
                            headline={headLines}
                            allDayNews={allDayNews}
                        />
                    </div>
                    <div className={styles.col_300}>
                        <Chip
                            id="286179"
                            type="recommend"
                            title="右侧顶部大图"
                            groupName="右侧顶部大图"
                            content={topBigImage}>
                            <ImageTextShadow />
                        </Chip>
                        <Space content={30} />
                        {/* <Chip id="260385" type="struct" title="右侧指数" groupName="右侧指数" content={rightStock}>
                            <Iframe />
                        </Chip> */}
                        <div id="fiu_aside" />
                        <Space content={30} />
                        <ModuleHead
                            chipConfig={{
                                id: '260376',
                                type: 'struct',
                                title: '港股调查所列表头',
                                groupName: '港股调查所',
                            }}
                            content={hkSurveyHead}
                        />
                        <Chip
                            id="286173"
                            type="recommend"
                            title="港股调查所列表"
                            groupName="港股调查所"
                            content={surveyList}>
                            <ImageTextShadow />
                        </Chip>
                        <Space content={30} />
                        <ModuleHead
                            chipConfig={{
                                id: '260377',
                                type: 'struct',
                                title: '会议头',
                                groupName: '会议头',
                            }}
                            content={meetingHead}
                        />
                        <Chip id="286174" type="recommend" title="会议列表" groupName="会议列表" content={meetingList}>
                            <ImageTextShadow />
                        </Chip>
                    </div>
                </div>
                <div className={styles.col_1000}>
                    <Chip id="260381" type="struct" title="大图广告" groupName="大图广告" content={longImageAd}>
                        <BigImageAd />
                    </Chip>
                </div>
                <div className={styles.col_1000}>
                    {/* <Chip id="260386" type="struct" title="下放指数" groupName="下放指数" content={bottomStock}>
                        <Iframe />
                    </Chip> */}
                    <div id="fiu_bottom" />
                </div>
                <BottomFooter content={footerData} />
                <ChipEdit transform={transform} />
            </>
        );
    }
}

export default errorBoundary(Layout);
